module.exports = __webpack_public_path__ + "img/success-join-shadow.7ddf49d3.svg";